import TaskManagerEditDto from './TaskManagerEditDto';

export class OpcDaWriterTaskEditDto extends TaskManagerEditDto {
    constructor() {
        super();

        /** @type {number} */
        this.opcDaWriter = null;

        /** @type {number} */
        this.optimizationPipeline = null;
    }

    /**
     * @typedef {Object} _OpcDaWriterTaskEditDto  Props
     * @property {number} opcDaWriter
     * @property {number} optimizationPipeline
     *
     * @typedef {import("./TaskManagerEditDto").TaskManagerEditDtoProps & _OpcDaWriterTaskEditDto Props} OpcDaWriterTaskEditDto Props
     */
    /**
     *
     * @param {OpcDaWriterTaskEditDto Props} props
     * @returns {OpcDaWriterTaskEditDto}
     */
    setup(props) {
        super.setup(props);

        this.opcDaWriter = props.opcDaWriter;
        this.optimizationPipeline = props.optimizationPipeline;

        return this;
    }
}

export default OpcDaWriterTaskEditDto;